module.exports = __webpack_public_path__ + "static/media/bb8-expand_more-24px.78fbcb86.svg";